import React from 'react';
import {
  Prelead,
  ProjectGroupPreleadCustomizeItem,
  PreleadProjectGroupCustomizeItemText,
  useUpdateProjectGroupPreleadCustomizeItemTextMutation,
} from 'api';
import {Input as UIInput} from 'components/antd';
import styled from 'styled-components';

interface Props {
  prelead: Prelead;
  projectGroupPreleadCustomizeItem: ProjectGroupPreleadCustomizeItem;
}

export default ({prelead, projectGroupPreleadCustomizeItem}: Props) => {
  const customizeItem = prelead.projectGroupCustomizeItemTexts.find(
    (item: PreleadProjectGroupCustomizeItemText) =>
      item.projectGroupPreleadCustomizeItemId ===
      projectGroupPreleadCustomizeItem.id,
  );

  const [value, setValue] = React.useState(
    customizeItem ? customizeItem.value : '',
  );

  React.useEffect(() => {
    setValue(customizeItem ? customizeItem.value : '');
  }, [customizeItem]);

  const [updateCustomizeItem] =
    useUpdateProjectGroupPreleadCustomizeItemTextMutation();

  const update = (e: any) => {
    updateCustomizeItem({
      variables: {
        uuid: prelead.uuid,
        projectGroupPreleadCustomizeItemId: projectGroupPreleadCustomizeItem.id,
        value: e.target.value,
      },
    });
  };

  return (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={update}
      onPressEnter={update}
      placeholder="未入力"
    />
  );
};

const Input = styled(UIInput)`
  border-color: transparent;
  background-color: transparent;
  border-radius: 4px;

  &:hover {
    border: 1px solid var(--text-color-3);
  }
`;
